export const GetNewTurn = (destinationLang) => {
  return [
    {
      FormKey: 'get-new-turn-label-select-desired-service',
      Key: 'خدمت مورد نظر خود را انتخاب کنید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-title-terms-condition',
      Key: 'قوانین اخذ نوبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-title-get-turn-based-on',
      Key: 'نوبت دهی بر اساس',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: 'get-new-turn-label-profession',
      Key: 'تخصص',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-check-accept-terms',
      Key: 'تمامی قوانین و مقررات را می پذیرم',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-time-period',
      Key: 'انتخاب بازه زمانی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-this-month',
      Key: '30 روز آینده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-this-week',
      Key: 'هفت روز آینده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-tommorow',
      Key: 'فردا',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-label-date-range',
      Key: 'بازه زمانی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-label-get-range',
      Key: 'دریافت بازه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-label-nearest-turn',
      Key: 'نزدیک ترین نوبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-alert-enter-account',
      Key: 'برای ادامه وارد حساب خود شوید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-back-step',
      Key: 'مرحله قبلی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-next-step',
      Key: 'مرحله بعدی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-btn-label-other-turns',
      Key: 'سایر نوبت ها',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'get-new-turn-get-turn-msg-you-turn-for-doctor',
      Key: 'نوبت شما برای پزشک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-get-turn-msg-you-turn-for',
      Key: 'جهت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-get-turn-msg-in-the-day',
      Key: 'در روز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-get-turn-msg-in-the-date',
      Key: 'مورخ',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-get-turn-msg-confirm',
      Key: 'ثبت شود؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-get-new-turn-confirm-msg',
      Key: 'آیا از اخذ نوبت اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-payment-based-on',
      Key: 'پرداخت با :',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-payment-based-on-wallet',
      Key: 'پرداخت از کیف پول',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'get-new-turn-payment-based-on-direct-payment',
      Key: 'پرداخت آنلاین',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-this-today-date',
      Key: 'امروز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-payment-label',
      Key: 'پرداخت از طریق : ',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-zarin-pal-portal',
      Key: 'زرین پال',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-select-saman-kish-pal-portal',
      Key: 'سامان کیش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-turn-label-full-queue',
      Key: 'سقف نوبت اینترنتی پر شده است',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-turn-label-cant-get-new-turn',
      Key: 'امکان اخذ نوبت وجود ندارد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'get-new-turn-appointments-full',
      Key: 'ظرفیت تکمیل است',
      DistinitationLanguage: destinationLang,
    },
  ];
};
